import { Box, Grid } from "@material-ui/core";
import { Title, useAuthenticated } from "react-admin";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import ProLogsDateFnsUtils from "../../../common/datetime/ProLogsDateFnsUtils";
import {
  HarshDrivingReportProvider,
  useHarshDrivingReport,
} from "./HarshDrivingReportContext";
import { HarshDrivingReportDashboardPickers } from "./HarshDrivingReportDashboardPickers";
import { HarshDrivingReportBaseMetricsWidget } from "./HarshDrivingReportBaseMetricsWidget";
import HarshEventsWidget from "./HarshEventsWidget";
import HarshEventsActiveDriverWidget from "./HarshEventsActiveDriverWidget";
import HarshReportsBestPerformers from "./HarshReportsBestPerformers";
import HarshReportsWorstPerformers from "./HarshReportsWorstPerformers";
import HarshDrivingTable from "./HarshDrivingTable";

const HarshDrivingReportContent = () => {
  useAuthenticated();
  const { reportParams } = useHarshDrivingReport();

  return (
    <div className="content-container">
      <Title title="resources.reports.harshDriving.name" />

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <HarshDrivingReportDashboardPickers />
        </Grid>

        <Grid item xs={12} md={5} style={{ display: "flex" }}>
          <Box flex={1} minHeight={0} display="flex">
            <HarshDrivingReportBaseMetricsWidget {...reportParams} />
          </Box>
        </Grid>
        <Grid item xs={12} md={7} style={{ display: "flex" }}>
          <Box flex={1} minHeight={0} display="flex">
            <HarshEventsWidget {...reportParams} />
          </Box>
        </Grid>

        <Grid item xs={12} md={3} style={{ display: "flex" }}>
          <Box flex={1} minHeight={0} display="flex">
            <HarshEventsActiveDriverWidget {...reportParams} />
          </Box>
        </Grid>
        <Grid item xs={12} md={9} style={{ display: "flex" }}>
          <Box flex={1} minHeight={0} display="flex">
            <HarshReportsBestPerformers {...reportParams} />
          </Box>
        </Grid>

        <Grid item xs={12} style={{ display: "flex" }}>
          <Box flex={1} minHeight={0} display="flex">
            <HarshReportsWorstPerformers {...reportParams} />
          </Box>
        </Grid>

        <Grid item xs={12}>
          <HarshDrivingTable {...reportParams} />
        </Grid>
      </Grid>
    </div>
  );
};

export const HarshDrivingReport = () => {
  return (
    <HarshDrivingReportProvider>
      <MuiPickersUtilsProvider utils={ProLogsDateFnsUtils}>
        <HarshDrivingReportContent />
      </MuiPickersUtilsProvider>
    </HarshDrivingReportProvider>
  );
};

export default HarshDrivingReport;
